const YOUTUBE_ID_PATTERNS = [
  /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([^&\n?#]+)/,
  /^([a-zA-Z0-9_-]{11})$/,
];

export const getYouTubeVideoId = (url) => {
  if (!url) return null;
  const value = String(url).trim();
  for (const pattern of YOUTUBE_ID_PATTERNS) {
    const match = value.match(pattern);
    if (match && match[1]) return match[1];
  }
  return null;
};

const isYouTubeHost = (hostname) => {
  const host = String(hostname || '').replace(/^www\./, '').toLowerCase();
  return host === 'youtube.com'
    || host === 'm.youtube.com'
    || host === 'youtu.be'
    || host === 'youtube-nocookie.com'
    || host.endsWith('.youtube.com');
};

/**
 * YouTube links keep the existing embed player.
 * Any other http(s) address is shown in that same player.
 */
export const getEmbeddableUrl = (url) => {
  if (!url) return null;
  const trimmed = String(url).trim();
  if (!trimmed) return null;

  const youtubeId = getYouTubeVideoId(trimmed);
  if (youtubeId) {
    const openUrl = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `https://www.youtube.com/watch?v=${youtubeId}`;
    return {
      kind: 'youtube',
      src: `https://www.youtube.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1`,
      openUrl,
    };
  }

  let parsed;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
  if (isYouTubeHost(parsed.hostname)) return null;
  return { kind: 'web', src: parsed.href, openUrl: parsed.href };
};
